module.exports = __webpack_public_path__ + "img/ad-ethvm.f7b2a74b.png";